import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const Logo = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography
        sx={{
          color: "#90CAF9",
          fontFamily: "Salsa",
          fontSize: "40px",
        }}
      >
        Med
      </Typography>
      <Typography sx={{ color: "secondary.dark", fontFamily: "Salsa", fontSize: "40px" }}>App</Typography>
    </Box>
  );
};

export default Logo;
